<div class="container">
  <p class="title">
    Data Analytics
    <mat-icon class="titleIcon">chevron_right</mat-icon>Total Ship Data
  </p>

  <div class="action-header-container" #filterContainer>
    <div class="modern-action-bar" style="margin-left: 0; margin-right: 0;">
      <div class="spacer"></div>
      <div class="right-filters" style="width: 100%;">
        <form [formGroup]="filterForm" class="filter-fields" style="width: 100%; display: flex; gap: 15px; align-items: flex-end;">
          
          <!-- Ship Name -->
          <div class="compact-multi-select">
            <input type="text" class="form-control" formControlName="shipName" placeholder="Enter ship name"
              style="height: 40px; background: rgba(255, 255, 255, 0.05); border: 1.5px solid rgba(255, 255, 255, 0.2); border-radius: 8px; color: white; padding: 0 12px;" />
          </div>

          <!-- IMO Number -->
          <div class="compact-multi-select">
            <input type="text" class="form-control" formControlName="imoNumber" placeholder="Enter IMO number"
              style="height: 40px; background: rgba(255, 255, 255, 0.05); border: 1.5px solid rgba(255, 255, 255, 0.2); border-radius: 8px; color: white; padding: 0 12px;" />
          </div>

          <!-- Cargo Type -->
          <div class="compact-multi-select">
            <div class="select-box" (click)="toggleCargoDropdown($event)">
              <span>{{ filterForm.get('cargoType')?.value || 'Select Cargo' }}</span>
              <mat-icon>expand_more</mat-icon>
            </div>
            <div class="dropdown-panel" *ngIf="cargoDropdownOpen" (click)="$event.stopPropagation()">
              <div class="search-container">
                <mat-icon>search</mat-icon>
                <input type="text" placeholder="Search Cargo..."
                  (input)="cargoSearchQuery = $any($event.target).value">
              </div>
              <div class="options-list">
                <div class="option" *ngFor="let cargo of getFilteredCargos()" (click)="onCargoSelect(cargo)">
                  <span>{{ cargo }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- ACTIONS -->
          <div class="filter-action-btns">
            <button class="icon-btn clear" (click)="clearClick()" title="Reset Filters" type="button">
              <mat-icon>clear_all</mat-icon>
            </button>
            <button class="icon-btn apply" (click)="filterClick()" title="Apply Filters" type="button">
              <mat-icon>done</mat-icon>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>


  <app-ch-skeleton *ngIf="isLoading" variant="table" [rows]="8" [cols]="7"></app-ch-skeleton>
  <div class="table-container scroll-bar" *ngIf="!isLoading">
    <table class="mat-elevation-z8 printable-table" id="style-4" matSort [ngClass]="{ 'dark-table': isDarkMode() }">
      <thead class="sticky-header">
        <tr>
          <th>S.No</th>
          <th>Ship Name</th>
          <th>IMO No</th>
          <th>Cargo Type</th>
          <th>Voyage Start Date</th>
          <th>Avg Temp Drop</th>
          <th>Min Temp Drop</th>
          <th>Max Temp Drop</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let ship of paginatedData; let i = index">
          <td>{{ currentPage * itemsPerPage + i + 1 }}</td>
          <td>{{ ship.shipName }}</td>
          <td>{{ ship.imo }}</td>
          <td>{{ ship.cargoType }}</td>
          <td>{{ ship.voyageStartDate }}</td>
          <td>{{ ship.avgTempDrop }}</td>
          <td>{{ ship.minTempDrop }}</td>
          <td>{{ ship.maxTempDrop }}</td>
        </tr>

      </tbody>
    </table>
  </div>
  <mat-paginator *ngIf="!isLoading" class="premium-paginator" [length]="totalShipData.length" [pageSize]="itemsPerPage" hidePageSize="true" (page)="onPageChange($event)"
    showFirstLastButtons [ngClass]="{ 'dark-paginator': isDarkMode() }"></mat-paginator>
  <br>
  <div class="d-flex justify-content-end gap-2">
    <button class="btn btn-light hover-button mail" (click)="downloadClick()">
      <mat-icon>download</mat-icon>&nbsp; Export
    </button>

    <button class="btn btn-light hover-button back-btn" (click)="goBack()" style="width: 150px;">
      <mat-icon>undo</mat-icon>&nbsp; Back
    </button>
  </div>

  <br>
</div>